import "../../../styles/stores/stockManagement/stockPage.css";
import { useEffect, useState } from "react";
import StockPage from "./StockPage";
import AddStockPage from "./AddStockPage";
import StockDetails from "./StockDetails";
import CheckStock from "./CheckStock";
import { ModalAlert } from "../../../components/alerts/modalAlert";
import AddProductByPhoto from "./addProductwithAuto/AIProductAdd/AddProductByAI";
import AddStockViaExcel from "./addStockCSVExcel/AddStockwithExcelAndCSV";

const StockHomePage = ({ setOpenCheckStock, socket }) => {
  const [page, setPage] = useState("stockManagement");
  const [productLists, setProductLists] = useState([]);

  const [selectedProduct, setSelectedProduct] = useState("");
  const [alertDisplay, setAlertDisplay] = useState({
    showAlert: false,
    type: "",
    title: "",
    message: "",
  });

  return (
    <>
      {page === "stockManagement" && (
        <StockPage
          updateSelectedProduct={setSelectedProduct}
          changePage={setPage}
          openModal={setOpenCheckStock}
          setAlertDisplay={setAlertDisplay}
          setProductLists={setProductLists}
        />
      )}
      {page === "addProductWithAI" && <AddProductByPhoto changePage={setPage} warehouse={false} setAlertDisplay={setAlertDisplay} socket={socket} />}
      {page === "addProductWithExcel" && <AddStockViaExcel changePage={setPage} warehouse={false} setAlertDisplay={setAlertDisplay} socket={socket} />}
      {page === "addStock" && (
        <AddStockPage changePage={setPage} warehouse={false} setAlertDisplay={setAlertDisplay} socket={socket} productLists={productLists} />
      )}
      {page === "stockDetails" && (
        <StockDetails
          changePage={setPage}
          product={selectedProduct}
          setAlertDisplay={setAlertDisplay}
          updateSelectedProduct={setSelectedProduct}
          socket={socket}
        />
      )}
      {/*    <CheckStock closeModal={setOpenCheckStock} openModal={openCheckStock ? "ShowCheckStockWrapper" : ""} /> */}

      <ModalAlert
        type={alertDisplay.type}
        showAlert={alertDisplay.showAlert}
        title={alertDisplay.title}
        message={alertDisplay.message}
        setAlertDisplay={setAlertDisplay}
      />
    </>
  );
};

export default StockHomePage;
